import React, { useContext } from 'react';
import { AccountContext } from '../../context/account';
import { UserContext } from '../../context/UserContext';

interface MemberAvatarProps {
  member: {
    id: string;
    displayName: string;
    user: {
      avatarUrl: string | null | undefined;
    };
  };
  size?: number;
}

const MemberAvatar: React.FC<MemberAvatarProps> = ({ member, size = 23 }) => {
  const accountContext = useContext(AccountContext);
  const { user } = useContext(UserContext);
  const memberId = user.memberIdForAccount(accountContext.selectedAccountId);

  function isEntryAuthor(): boolean {
    return member.id === memberId;
  }

  return (
    <>
      {member.user.avatarUrl ? (
        <div
          className="flex-none br-100 cover"
          style={{
            background: `url(${member.user.avatarUrl}) center center no-repeat`,
            height: size,
            width: size
          }}
        />
      ) : (
        <div
          className={`flex-none flex justify-center items-center f8 br-100 center ${
            isEntryAuthor() ? 'bg-white navy ba b--navy' : 'bg-navy white'
          }`}
          style={{ width: size, height: size }}
        >
          {member.displayName[0].toUpperCase()}
        </div>
      )}
    </>
  );
};

export default MemberAvatar;
